//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'

import { ONE_SECOND } from '@happstv/shared/util/timeConstants'

import VerticalStepList from '@/components/universal/layout/VerticalStepList.vue'
import Footer from '@/components/universal/navigation/Footer.vue'
import ReachLogo from '@/assets/svg/app/ReachLogo.vue'

const RESET_TIMER_SECONDS = 30

export default {
  name: 'AuthPage',
  components: {
    VerticalStepList,
    Footer,
    ReachLogo,
  },
  data() {
    return {
      resendTimer: 0,
    }
  },
  computed: {
    ...mapState([
      'isMobile',
      'signedInUser',
      'signedInFirebaseUser',
    ]),
    ...mapState('referral', [
      'referralInfo',
    ]),
    ...mapGetters('auth', [
      'authStepComponentList',
    ]),

    referralCodeQuery() {
      return this.$route.query.referralCode
    },
    shouldCompleteReferral() {
      const { referralInfo, signedInUser } = this
      return Boolean(
        referralInfo
        && signedInUser
        && signedInUser.fullName
        && !signedInUser.approvedForStarlight
      )
    },
    signedInFirebaseUserExists() {
      return Boolean(this.signedInFirebaseUser)
    },
  },
  watch: {
    referralCodeQuery: {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue !== (this.referralInfo || {}).referralCode) {
          this.$store.dispatch('referral/VALIDATE_REFERRAL', newValue.toUpperCase())
        }
      },
    },
    referralInfo: {
      immediate: true,
      handler(newValue, oldValue) {
        const { referralCode } = newValue || {}
        const oldReferralCode = (oldValue || {}).referralCode
        if ((referralCode || oldReferralCode) && referralCode !== this.referralCodeQuery) {
          this.$router.replace({ query: { referralCode } })
        }
      },
    },
    shouldCompleteReferral: {
      immediate: true,
      async handler(newValue) {
        if (newValue) {
          const { referralCode, referrerUserId } = this.referralInfo
          this.$store.dispatch('analytics/LOG_EVENT', {
            name: 'referral_completion_initiated',
            data: {
              referralCode,
              referrerUserId,
            },
          })
          const { success, error } = await this.$store.dispatch('referral/COMPLETE_REFERRAL')
          this.$store.dispatch('analytics/LOG_EVENT', {
            name: 'referral_completion_returned',
            data: {
              referralCode,
              referrerUserId,
              success,
              error,
            },
          })
        }
      },
    },
    signedInFirebaseUserExists: {
      immediate: true,
      handler(newValue) {
        if (newValue) this.resendTimer = 0
      },
    },
  },
  methods: {
    resendSms() {
      const { phoneStep } = this.$refs
      if (phoneStep) phoneStep.sendSms()
    },

    startResendCountdown(secondsRemaining) {
      let secondsLeft = secondsRemaining || RESET_TIMER_SECONDS

      localStorage.setItem('resendTimerEndTime', Date.now() + secondsLeft * ONE_SECOND)

      const timerId = setInterval(countdown, 1000)
      const component = this

      function countdown() {
        if (secondsLeft <= 0) {
          clearTimeout(timerId)
          component.resendTimer = 0
          localStorage.removeItem('resendTimerEndTime')
        } else {
          component.resendTimer = secondsLeft
          secondsLeft--
        }
      }
    },
  },
  mounted() {
    this.$store.dispatch('analytics/LOG_EVENT', { name: 'auth_flow_viewed' })
    this.$store.commit('auth/SET_USER_REQUESTED_AUTH', false)
    const endTime = localStorage.getItem('resendTimerEndTime')
    const secondsRemaining = Math.floor(Math.max(0, endTime - Date.now()) / ONE_SECOND)
    if (secondsRemaining > 0) {
      this.startResendCountdown(secondsRemaining)
    }
  },
}
